/* eslint-disable */
import React, { useEffect, useRef, useState } from "react";
import * as API from '../../framework/API/api'
import { Checkbox } from "@progress/kendo-react-inputs";
import { Form, Field, FormElement } from "@progress/kendo-react-form";
import { DAYS, ENTITYNAME, OPERATORS, PROTOTYPE_RESTRICTION_TYPE, TOAST_TYPES } from "../../framework/constant/constant";
import { Grid, GridColumn } from "@progress/kendo-react-grid";
import { DropDownList, MultiSelect } from "@progress/kendo-react-dropdowns";
import { useTranslation } from "../../locale/useTranslation";
import AddRoundButton from "../../framework/forms/helpercomponents/buttons/AddRoundButton";
import SaveRoundButton from "../../framework/forms/helpercomponents/buttons/SaveRoundButton";
import CancelRoundButton from "../../framework/forms/helpercomponents/buttons/CancelRoundButton";
import EditRoundButton from "../../framework/forms/helpercomponents/buttons/EditRoundButton";
import DeleteRoundButton from "../../framework/forms/helpercomponents/buttons/DeleteRoundButton";
import { ConfirmDeleteAlert } from '../../ConfirmAlert'
import { utility } from "../../framework/utility/utilityProvider";
import SaveButton from "../../framework/forms/helpercomponents/buttons/SaveButton";
import CancelButton from "../../framework/forms/helpercomponents/buttons/CancelButton";
import { ArrayCell } from "../../framework/forms/helpercomponents/CustomGridCells/ArrayCell";
import { TimeCell } from "../../framework/forms/helpercomponents/CustomGridCells/TimeCell";
import { DateCell, DateOnlyCell } from "../../framework/forms/helpercomponents/CustomGridCells/DateCell";
import moment from "moment";
import BossDialog from "../../components/BossDialog";
import { TimePickerWithFormat } from "../../framework/forms/helpercomponents/timepicker/TimePickerWithFormat";
import ToastNotification from "../../components/ToastNotification";

function PrototypeRestrictionEditForm(props) {

  let blankDataItem = {
    PrototypeRestrictionType: {},
    Value:  null,
    Operator: null
  }
  const [dataItem, setDataItem] = useState(blankDataItem);
  const selectedIndexRef = useRef(0);
  const setSelectedIndexRef = (data) => {
    selectedIndexRef.current = data;
  }
  const [channel, setChannel] = useState([]);
  const [i, setI] = useState(0);
  const [editMode, setEditMode] = useState(false);
  const [toggle, setToggle] = useState(false);
  const lang = useTranslation();
  const [prototypeRestriction, setPrototypeRestriction] = useState([]);
  const [prototypeRestrictionTypes, setPrototypeRestrictionTypes] = useState([]);
  const [pgRatings, setPgRatings] = useState([]);

  useEffect(() => {
    loadcombo();
  }, []);

  const onChange = (e) => {
    const { name } = e.target;
    if (e.value !== undefined) { setDataItem(prev => ({ ...prev, [name]: e.value })); }
    else { setDataItem(prev => ({ ...prev, [name]: e.target.value })); }
  };
  const loadcombo = async () => {
    let prototypeRestrictionTypeRes = Object.keys(PROTOTYPE_RESTRICTION_TYPE).map((x) => {
      return { _id: PROTOTYPE_RESTRICTION_TYPE[x], Description: x }
    })
    setPrototypeRestrictionTypes(prototypeRestrictionTypeRes);

    const pgRatingRes = await API.getDataLookup(ENTITYNAME.PGRating, { sort: { Description: 1 } });
    setPgRatings(pgRatingRes.data);
  }


  const isValid = () => {

    if (!dataItem.PrototypeRestrictionType || Object.keys(dataItem.PrototypeRestrictionType).length === 0) {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_select_type_error_message });
      return false;
    }

    if (dataItem.PrototypeRestrictionType?._id === PROTOTYPE_RESTRICTION_TYPE.SLOT_TIME) {

      if (!dataItem.Operator || Object.keys(dataItem.Operator).length === 0) {
        ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_select_operator_error_message });
        return false;
      }
    }

    if (dataItem.PrototypeRestrictionType?._id === PROTOTYPE_RESTRICTION_TYPE.PG_RATING) {

      if (!dataItem.Value || Object.keys(dataItem.Value).length === 0) {
        ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_select_pg_rating_error_message });
        return false;
      }
    }

    if (dataItem.PrototypeRestrictionType?._id === PROTOTYPE_RESTRICTION_TYPE.DATE_PERIOD) {

      if (!utility.isValidDate(dataItem.FromDate)) {
        ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_select_from_date_error_message });
        return false;
      }

      if (!utility.isValidDate(dataItem.ToDate)) {
        ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_select_to_date_error_message });
        return false;
      }

      if (dataItem.ToDate <= dataItem.FromDate) {
        ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_select_to_date_grater_then_from_date_error_message });
        return false;
      }
    }

    if (dataItem.PrototypeRestrictionType?._id === PROTOTYPE_RESTRICTION_TYPE.DAYS) {

      if (!dataItem.Value || dataItem.Value.length === 0) {
        ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_select_days_error_message });
        return false;
      }
    }

    return true;
  };

  const buildValueByType = (item) => {
    const type = item?.PrototypeRestrictionType?._id;

    switch (type) {
      case PROTOTYPE_RESTRICTION_TYPE.SLOT_TIME:
        return {
          Value: {
            Operator: item?.Operator?.ID,
            Value: item?.Value !== null && item?.Value !== undefined && item?.Value !== "" ? utility.convertShortTimeStringToMilliSeconds(item.Value) : utility.convertShortTimeStringToMilliSeconds("00:00") 
          }
        };
      case PROTOTYPE_RESTRICTION_TYPE.PG_RATING:
        return {
          Value: item?.Value ? { _id: item.Value._id, Description: item.Value.Description } : null
        };
      case PROTOTYPE_RESTRICTION_TYPE.DATE_PERIOD:
        return {
          Value: {
            FromDate: item?.FromDate ? utility.convertStringDatetoMilliseconds(item.FromDate) : null,
            ToDate: item?.ToDate ? utility.convertStringDatetoMilliseconds(item.ToDate) : null
          }
        };
      case PROTOTYPE_RESTRICTION_TYPE.DAYS:
        return { Value: item?.Value?.length > 0 ? item.Value.map(x => x.ID) : [] };

      default:
        return { Value: null };
    }
  };
  const addRestriction = () => {
    if (!isValid()) return;
    const built = buildValueByType(dataItem);
    const newItem = {
      PrototypeRestrictionType: dataItem?.PrototypeRestrictionType?._id,
      ...built
    };
    props.setRestrictionData([...props.data, newItem]);
    clearData();
  };

  const MyCommandCell = (props) => (
    <div className="mt-1" style={{ display: "flex" }}>
      <EditRoundButton onClick={() => editFormGrid(props)} />
      <DeleteRoundButton onClick={() => ConfirmDeleteAlert(() => removeRestrictionData(props.dataIndex), () => { })} />
    </div>
  )

  const editFormGrid = (data) => {
    const item = data.dataItem;
    const type = item?.PrototypeRestrictionType;

    let updated = { PrototypeRestrictionType: prototypeRestrictionTypes.find(x => x._id === type) };

    if (type === PROTOTYPE_RESTRICTION_TYPE.SLOT_TIME) {
      updated.Operator = OPERATORS.find(op => op.ID === item?.Value?.Operator) || null;
      updated.Value = item?.Value?.Value !== null && item?.Value?.Value !== undefined ? utility.convertMilisecondsToShortTimeString(item.Value.Value) : utility.convertMilisecondsToShortTimeString("00:00");
    }
    if (type === PROTOTYPE_RESTRICTION_TYPE.DATE_PERIOD) {
      updated.FromDate = item?.Value?.FromDate ? utility.convertMilisecondsToDateString(item.Value.FromDate) : "";
      updated.ToDate = item?.Value?.ToDate ? utility.convertMilisecondsToDateString(item.Value.ToDate) : "";
    }
    if (type === PROTOTYPE_RESTRICTION_TYPE.PG_RATING) { updated.Value = item.Value || null; }
    if (type === PROTOTYPE_RESTRICTION_TYPE.DAYS) {
      updated.Value = item?.Value?.length > 0 ? DAYS.filter(day => item.Value.includes(day.ID)) : [];
    }

    setSelectedIndexRef(data.dataIndex);
    setDataItem(updated);
    setEditMode(true);
    setToggle(true);
  };
  const removeRestrictionData = (index) => {
    if (props.data.length == 1) {
      props.setRestrictionData([]);
      setI(i - 1);
      console.log(i);
      // clearData();
    }
    else {
      // console.log(index);
      props.setRestrictionData([
        ...props.data.slice(0, index),
        ...props.data.slice(index + 1, props.data.length)
      ]);
      // clearData();
      setI(i - 1);
    }
    ToastNotification({ type: TOAST_TYPES.SUCCESS, title: lang.success_message_title, message: lang.delete_successfully_grid_data_success_toast_message });
  }

  const handleSubmit = () => {
    if (!isValid()) return;
    let local = [...props.data];
    const built = buildValueByType(dataItem);
    local[selectedIndexRef.current] = {
      PrototypeRestrictionType: dataItem?.PrototypeRestrictionType?._id,
      ...built
    };
    props.setRestrictionData(local);
    clearData();
  };

  const clearData = () => {
    setDataItem(blankDataItem);
    setEditMode(false);
    setToggle(false);
  }
  const ValueCell = (props) => {
    const item = props.dataItem;
    const type = item?.PrototypeRestrictionType;

    let display = "";

    switch (type) {
      case PROTOTYPE_RESTRICTION_TYPE.SLOT_TIME:
        const operatorObj = OPERATORS.find(op => op.ID === item?.Value?.Operator);
        display = item?.Value?.Value !== null && item?.Value?.Value !== undefined ? `${operatorObj?.Description || ""}, ${utility.convertMilisecondsToShortTimeString(item?.Value?.Value)}` : `${operatorObj?.Description || ""}, ${utility.convertMilisecondsToShortTimeString("00:00")}`;
        break;

      case PROTOTYPE_RESTRICTION_TYPE.PG_RATING:
        display = item?.Value?.Description ?? "";
        break;

      case PROTOTYPE_RESTRICTION_TYPE.DATE_PERIOD:
        display = item?.Value ? `${utility.convertMilisecondsToDateString(item?.Value?.FromDate)} - ${utility.convertMilisecondsToDateString(item?.Value?.ToDate)}` : "";
        break;

      case PROTOTYPE_RESTRICTION_TYPE.DAYS:
        display = item?.Value?.length > 0 ? DAYS.filter(day => item?.Value?.includes(day.ID)).map(x => x?.Name).join(", ") : "";
        break;

      default:
        display = "";
    }

    return <td>{display}</td>;
  };

  return (
    <div className="row">
      <div className={"col-12"}>
        <AddRoundButton style={{ marginBottom: '5px' }} onClick={() => setToggle(true)}></AddRoundButton>
        <Grid data={props.data} style={{ height: "30vh", marginBottom: "20px" }}>
          <GridColumn cell={MyCommandCell} width={"70px"} locked={true} />
          {/* <GridColumn field="PrototypeRestrictionType.Description" title="Type" /> */}
          <GridColumn
            title="Type"
            cell={(props) => {
              const typeId = props?.dataItem?.PrototypeRestrictionType;
              const typeObj = prototypeRestrictionTypes.find(x => x?._id === typeId);
              return <td>{typeObj?.Description || ""}</td>;
            }}
          />
          <GridColumn title="Value" cell={ValueCell} />
        </Grid>
      </div>
      {toggle &&
        <BossDialog
          title={Object.keys(dataItem.PrototypeRestrictionType).length > 0 ? dataItem.PrototypeRestrictionType.Description : `${lang.create_restriction_dialog_header}`}
          onClose={() => setToggle(false)}
          width={700}
        >
          <div className="row">
            <div className="col-12">
              <Form
                render={(formRenderProps) => (
                  <FormElement>
                    <div className="row mt-2">
                      <div className="marlr">
                        {!editMode && <SaveButton onClick={() => addRestriction()} />}
                        {editMode && <SaveButton onClick={() => { handleSubmit() }} />}
                        <CancelButton onClick={clearData} />
                      </div>
                    </div>
                    <div className=" mt-2" style={{ border: "groove 1px" }}>
                      <div className="row mb-3 ml-1 mr-1 mt-2">
                        <div className="col-4">
                          <label htmlFor="TabView">{lang.type_label} *</label>
                          <DropDownList
                            style={{ backgroundColor: "white" }}
                            data={prototypeRestrictionTypes}
                            name="PrototypeRestrictionType"
                            textField="Description"
                            dataItemKey="_id"
                            value={dataItem.PrototypeRestrictionType}
                            onChange={onChange}
                            validator={(value) => value ? "" : "Please select the value"}
                          />
                        </div>
                        {dataItem?.PrototypeRestrictionType?._id === PROTOTYPE_RESTRICTION_TYPE.SLOT_TIME &&
                          <>
                            <div className="col-4">
                              <label htmlFor="TabView">{lang.operator_label} *</label>
                              <DropDownList
                                data={OPERATORS}
                                name="Operator"
                                textField="Description"
                                dataItemKey="ID"
                                value={dataItem.Operator || null}
                                onChange={onChange}
                                className='form-control form-control-sm'
                              />
                            </div>
                            <div className="col-4">
                              <label htmlFor="TabView">{lang.value_label} *</label>
                              <TimePickerWithFormat
                                isWithFrames={false}
                                name="Value"
                                value={dataItem.Value}
                                onChange={onChange}
                                className='form-control form-control-sm'
                              />
                            </div>
                          </>
                        }
                        {dataItem?.PrototypeRestrictionType?._id === PROTOTYPE_RESTRICTION_TYPE.PG_RATING &&
                          <div className="col-6">
                            <label htmlFor="TabView">{lang.pg_rating_label} *</label>
                            <DropDownList
                              data={pgRatings}
                              name={"Value"}
                              textField="Description"
                              dataItemKey="_id"
                              value={dataItem.Value}
                              onChange={onChange}
                              className='form-control form-control-sm'
                            />
                          </div>
                        }
                        {dataItem?.PrototypeRestrictionType?._id === PROTOTYPE_RESTRICTION_TYPE.DATE_PERIOD &&
                          <>
                            <div className="col-4">
                              <label htmlFor="">{lang.from_date_label} *</label>
                              <input
                                type="date"
                                className="form-control form-control-sm"
                                name="FromDate"
                                value={dataItem.FromDate}
                                onChange={onChange}
                              />
                            </div>
                            <div className="col-4">
                              <label htmlFor="">{lang.to_date_label} *</label>
                              <input
                                type="date"
                                className="form-control form-control-sm"
                                name="ToDate"
                                value={dataItem.ToDate}
                                onChange={onChange}
                              />
                            </div>
                          </>
                        }
                        {dataItem?.PrototypeRestrictionType?._id === PROTOTYPE_RESTRICTION_TYPE.DAYS &&
                          <div className="col-6">
                            <label htmlFor="TabView">{lang.days_label} *</label>
                            <MultiSelect
                              style={{ backgroundColor: "white" }}
                              data={DAYS}
                              name="Value"
                              textField="Name"
                              dataItemKey="ID"
                              value={dataItem.Value}
                              onChange={onChange}
                            />
                          </div>
                        }
                      </div>
                    </div>
                  </FormElement>
                )} />
            </div>
          </div>
        </BossDialog>}
    </div>
  )
}

export default PrototypeRestrictionEditForm